import { displayToast, sendAppsignalError } from "../modules/utils";

class DashboardPage {
  constructor(node) {
    this.element = node;
    this.turnoverTarget = this.element.querySelector(".js-turnover-target");
    this.distributorGoalTarget = this.element.querySelector(".js-distributor-goal");
    this.doughnutWrapperTarget = this.element.querySelector(".js-doughnut-wrapper");
    this.statisticsLinkTargets = this.element.querySelectorAll(".js-statistics-link");
    this.todosWrapperTarget = this.element.querySelector(".js-todos-wrapper");
    this.initialize();
  }

  initialize() {
    this.turnoverTarget.addEventListener("ajax:post", (e) => {
      this.updateContent(e);
    });

    this.distributorGoalTarget.addEventListener("ajax:post", (e) => {
      this.updateContent(e);
    });

    this.addDoughnutCartEventListeners();

    this.initializeTodos();
  }

  initializeTodos() {
    this.todosWrapperTarget.querySelectorAll("input[type='checkbox'").forEach((todo) => {
      todo.addEventListener("click", () => {
        const url = new URL(this.element.dataset.todoUrl, window.location.origin);
        this.todosWrapperTarget.classList.add("is-loading");

        const formData = new FormData();
        formData.append("id", todo.id);

        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            }

            throw new Error("Something went wrong");
          })
          .then((data) => {
            const object = {
              detail: {
                html: data.html,
              },
              target: this.todosWrapperTarget,
            };

            this.updateContent(object);
            this.initializeTodos();
          })
          .catch((e) => {
            console.error(e);
            displayToast(this.element.dataset.errorMessage);
            sendAppsignalError(e, "Dashboard", {
              response: this.response,
            });
          })
          .finally(() => {
            this.todosWrapperTarget.classList.remove("is-loading");
          });
      });
    });
  }

  updateContent(e) {
    const { detail, target } = e;
    const { html } = detail;

    target.innerHTML = html;
  }

  addDoughnutCartEventListeners() {
    const doughnutFilterDateTarget = this.element.querySelector(".js-dashboard-doughnut-filter-date");

    doughnutFilterDateTarget.addEventListener("datepicker-change", () => {
      const url = new URL(this.element.dataset.doughnutHtmlUrl, window.location.origin);
      url.searchParams.set(doughnutFilterDateTarget.name, doughnutFilterDateTarget.value);

      doughnutFilterDateTarget.blur();

      this.fetchDoughnutContent(url);
      this.updateStatisticsLinks(doughnutFilterDateTarget.name, doughnutFilterDateTarget.value);
    });
  }

  updateStatisticsLinks(name, value) {
    this.statisticsLinkTargets.forEach((link) => {
      const baseUrl = new URL(link.href, window.location.origin);
      baseUrl.searchParams.set(name, value);

      link.href = baseUrl;
    });
  }

  fetchDoughnutContent(url) {
    fetch(url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const object = {
          detail: {
            html: data.html,
          },
          target: this.doughnutWrapperTarget,
        };

        this.updateContent(object);

        window.Beyuna.initClasses(this.doughnutWrapperTarget);
        this.addDoughnutCartEventListeners();
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.trigger.dataset.errorMessage);
        sendAppsignalError(e, "Dashboard", {
          response: this.response,
        });
      });
  }
}

const dashboard = document.querySelector("[ data-js='dashboard']");

if (dashboard) {
  new DashboardPage(dashboard);
}
